import Model from '@/models/Model.js';

export default class MeetingParticipantLog extends Model {
    static entity = 'meeting_participant_logs';

    static fields() {
        return {
            id: this.attr(null),
            meeting_id: this.attr(null),
            user_id: this.attr(null),
            meeting_user_id: this.attr(null),
            meeting_participant_id: this.attr(null),
            provider_participant_id: this.attr(null),
            provider_user_id: this.attr(null),
            provider_email: this.attr(null),
            provider_name: this.attr(null),
            join_time: this.attr(null),
            leave_time: this.attr(null),
            duration: this.attr(null),

            ...super.fields(),

            meeting: this.belongsTo('meetings', 'meeting_id'),
            user: this.belongsTo('users', 'user_id'),
            meeting_user: this.belongsTo('meeting_users', 'meeting_user_id'),
            meeting_participant: this.belongsTo('meeting_participants', 'meeting_participant_id'),
        };
    }

    get name() {
        if (!this.user_id) {
            return this.provider_name;
        }

        return this.user.name;
    }
}
